module.exports = __webpack_public_path__ + "project-content-media-player.png";